import React, { useState } from 'react';
import { FiImage, FiSettings } from 'react-icons/fi';
import InstagramFeedPanel from './InstagramFeedPanel';
import InstagramSettingsPanel from './InstagramSettingsPanel';
import './MarketingInstagram.css';
import '../MarketingKalender.css';

export default function MarketingInstagram() {
  const [subTab, setSubTab] = useState('feed');

  return (
    <div className="marketing-ig-page">
      <header className="marketing-ig-page-header">
        <div>
          <h1>
            <FiImage aria-hidden /> Instagram
          </h1>
          <p className="muted">
            Geplande en gepubliceerde posts — via <strong>Nieuwe post</strong>, dagdeal-import, of de marketingkalender.
          </p>
        </div>
      </header>

      <nav className="marketing-ig-subnav" aria-label="Instagram secties">
        <button
          type="button"
          className={subTab === 'feed' ? 'active' : ''}
          onClick={() => setSubTab('feed')}
        >
          <FiImage /> Postoverzicht
        </button>
        <button
          type="button"
          className={subTab === 'settings' ? 'active' : ''}
          onClick={() => setSubTab('settings')}
        >
          <FiSettings /> Instellingen
        </button>
      </nav>

      {subTab === 'feed' ? <InstagramFeedPanel /> : <InstagramSettingsPanel />}
    </div>
  );
}
